// 业务核心数据中心
const map = {
  businessCoreData: () => import('@/views/businessCoreData'),
  businessOperationTable: () => import('@/views/businessCoreData/businessOperationTable'), // 业务经营损益表
  businessOperationPdTable: () => import('@/views/businessCoreData/businessOperationPdTable') // 业务经营损益表
}

export default map
